import { useState } from "react";
import Config from "../../Config";
 

import Books from "./Books";
import Spec from "./Spec";
import Specjalista from "./Specjalista";

function MenView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

 
 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);   
    }

    
    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
 
 

    if(props.mainView.viewSelected == "start") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "spec") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "specjalisty") tab3 = tab3 + " selected";
 
 
 

    var subMenu = <div className="submenu ">
            <div className={tab1} module="men" view="start" id="" onClick={props.mainView.quickGo} >Dzienniki grup</div>        
            <div className={tab2} module="men" view="spec" id="" onClick={props.mainView.quickGo} >Specjalistyczne</div>
            <div className={tab3} module="men" view="specjalisty" id="" onClick={props.mainView.quickGo} >Specjalisty</div>
    </div>


    var emen = <div className="emen_title">
        E-DZIENNIK
    </div>


    if(props.mainView.viewSelected == 'start' || props.mainView.viewSelected == undefined )
        {
            document.title ="E-Dziennik Men - Wg. grup"; 
            return (
                <div className="econtent  e_mem">     
                                {emen}                      
                                {subMenu}        
                                <Books  userData={props.userData}  mainView={props.mainView}  /> 
                 </div>
            )
        }

    if(props.mainView.viewSelected == 'spec' )
        {
            document.title ="E-Dziennik Men - Specjalistyczne"; 
            return (
                <div className="econtent  e_mem">    
                                {emen}                                                         
                                {subMenu}    
                                <Spec  userData={props.userData}  mainView={props.mainView}  />     

                 </div>
            )
        }

    
        if(props.mainView.viewSelected == 'specjalisty' )
        {
            document.title ="E-Dziennik Men - Dziennik specjalisty"; 
            return (
                <div className="econtent  e_mem">    
                                {emen}                                                         
                                {subMenu}
                                <Specjalista  userData={props.userData}  mainView={props.mainView}  />

                 </div>
            )
        }
   



    return (
        <div className="econtent ">
             { "View, op: " +  props.mainView.viewSelected}
        </div>
    );

}


export default MenView